export default __webpack_public_path__ + "static/media/2074.d2661271.png";